<template>
  <div v-show="widget.show && widget.pageId == pageId">
    <vue-drag-resize
      :w="widget.size?.w || 100"
      :h="widget.size?.h || 100"
      :x="widget.size?.x || 0"
      :y="widget.size?.y || 0"
      :parent-w="windowWidth"
      :parent-h="windowHeight - 100"
      :parent-limitation="true"
      :minw="widget.size?.minw || 50"
      :minh="widget.size?.minh || 50"
      :sticks="resizeSticks"
      :is-draggable="dragEnabled"
      :is-resizable="$store.state.edit"
      :is-active="$store.state.edit"
      :prevent-active-behavior="false"
      :snap-to-grid="true"
      :grid-x="6"
      :grid-y="6"
      @activated="activate"
      @deactivated="deactivate"
      @resizing="resize"
      @dragging="resize"
      @dragstop="stopMove"
      @resizestop="deactivate"
    >
      <v-card
        :height="widget.size?.h || 200"
        :width="widget.size?.w || 300"
        :class="cardClasses"
        class="widget-card"
      >
        <div v-if="showSettingButton" class="widget-setting-wrap">
          <v-btn
            icon
            small
            class="widget-setting-btn"
            @click.stop="Setting()"
          >
            <v-icon small>mdi-cog</v-icon>
          </v-btn>
        </div>

        <div
          v-if="$store.state.deleteMode"
          class="delete-overlay"
          @click.stop="deleteWidget"
        >
          <v-icon class="delete-overlay__icon">mdi-trash-can</v-icon>
        </div>

        <div v-if="$store.state.edit" class="move-overlay">
          <div class="move-overlay__inner">
            <div
              class="move-overlay__move-btn"
              @mousedown="startMove"
              @touchstart="startMove"
              title="Move widget"
            >
              <v-icon class="move-overlay__icon">mdi-arrow-all</v-icon>
            </div>
          </div>
        </div>

        <div :class="bodyClasses">
          <v-list-item-content two-lines>
            <v-list-item-title class="widget-title">
              {{ widget.name }}
            </v-list-item-title>

            <v-list-item-subtitle class="widget-subtitle">
              <span v-if="widget.timestamp">
                {{ new Date(widget.timestamp).toLocaleDateString("th-TH") }}
                {{ new Date(widget.timestamp).toLocaleTimeString("th-TH") }}
              </span>
            </v-list-item-subtitle>
          </v-list-item-content>

          <div :class="contentClasses">
            <component
              :is="widget.type"
              :widget="widget"
              style="overflow: hidden"
            />
          </div>
        </div>
      </v-card>
    </vue-drag-resize>

    <v-dialog
      v-model="setting"
      max-width="1040px"
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card class="setting-dialog-card">
        <div class="setting-dialog__header">
          <div class="setting-dialog__header-left">
            <div class="setting-dialog__eyebrow">WIDGET SETTINGS</div>
            <div class="setting-dialog__title">
              {{ widget.name || widget.type }}
            </div>
            <div class="setting-dialog__subtitle">
              ปรับแต่งข้อมูลและหน้าตาของ {{ widget.type }}
            </div>
          </div>

          <v-btn icon class="setting-dialog__close" @click="setting = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <div class="setting-dialog__content">
          <div class="setting-dialog__main">
            <v-tabs
              v-model="settingTab"
              background-color="transparent"
              color="#6f42c1"
              slider-color="#6f42c1"
              class="setting-tabs"
            >
              <v-tab>General</v-tab>
              <v-tab>Data</v-tab>
              <v-tab>Style</v-tab>
            </v-tabs>

            <v-tabs-items v-model="settingTab" class="setting-tabs-items">
              <v-tab-item>
                <div class="setting-section">
                  <div class="setting-section__title">ข้อมูลทั่วไป</div>

                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-if="Object.keys(widget).includes('name')"
                        v-model="widget.name"
                        label="Widget Name"
                        outlined
                        dense
                        hide-details="auto"
                        class="setting-input"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select
                        v-model="editOrder"
                        :items="availableOrderOptions"
                        label="Widget Order"
                        outlined
                        dense
                        hide-details="auto"
                        class="setting-input"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>

              <v-tab-item>
                <div class="setting-section">
                  <div class="setting-section__title">Data source</div>

                  <v-row dense>
                    <v-col cols="12">
                      <v-select
                        v-if="
                          Object.keys(widget).includes('topic') &&
                          widget.deviceType !== 'control'
                        "
                        :items="availableTopicItems"
                        item-text="text"
                        item-value="value"
                        label="Topic"
                        no-data-text="ยังไม่มี Topic ใน Token นี้"
                        v-model="widget.topic"
                        outlined
                        dense
                        hide-details="auto"
                        class="setting-input"
                      />
                    </v-col>
                  </v-row>
                </div>

                <div v-if="widget.params" class="setting-section">
                  <div class="setting-section__title">Parameters</div>

                  <v-row dense>
                    <v-col
                      v-for="(p, i) in Object.keys(widget.params)"
                      :key="i"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-text-field
                        v-if="p !== 'Color' && p !== 'Load'"
                        v-model="widget.params[p]"
                        :label="p"
                        outlined
                        dense
                        hide-details="auto"
                        class="setting-input"
                      />

                      <v-select
                        v-if="hasParams() && p === 'Load'"
                        :items="load_type"
                        item-text="Load"
                        label="Load Type"
                        v-model="widget.params[p]"
                        outlined
                        dense
                        hide-details="auto"
                        class="setting-input"
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-tab-item>

              <v-tab-item>
                <div class="setting-section">
                  <div class="setting-section__title">Appearance</div>

                  <div
                    v-if="hasParams() && widget.params.Color"
                    class="setting-color-box"
                  >
                    <div class="setting-color-box__top">
                      <span class="setting-color-box__label">Selected color</span>
                      <div
                        class="setting-color-box__preview"
                        :style="{ background: widget.params.Color }"
                      ></div>
                    </div>

                    <div class="setting-color-box__name">
                      {{ currentColorName }}
                    </div>

                    <div class="setting-color-grid">
                      <button
                        v-for="(color, index) in colorOptions"
                        :key="index"
                        type="button"
                        class="setting-color-swatch"
                        :class="{
                          'setting-color-swatch--active':
                            widget.params.Color === colorHexMap[color]
                        }"
                        :style="{ background: colorHexMap[color] }"
                        @click="setColor(color)"
                      ></button>
                    </div>
                  </div>

                  <div v-else class="setting-empty">
                    Widget นี้ไม่มีตัวเลือก style เพิ่มเติม
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>

          <div class="setting-dialog__preview">
            <div class="preview-card">
              <div class="preview-card__eyebrow">LIVE PREVIEW</div>

              <div class="preview-card__widget" :style="previewWidgetStyle">
                <div class="preview-card__widget-header">
                  <div class="preview-card__widget-title">
                    {{ widget.name || widget.type }}
                  </div>
                  <div
                    class="preview-card__widget-dot"
                    :style="previewAccentStyle"
                  ></div>
                </div>

                <div class="preview-card__widget-box" :style="previewBoxStyle">
                  <v-icon :size="previewIconSize" :color="previewIconColor">
                    {{ previewIcon }}
                  </v-icon>
                </div>

                <div class="preview-card__widget-footer">
                  <div
                    v-if="hasParams() && widget.params.Color"
                    class="preview-meta-chip preview-meta-chip--color"
                  >
                    <span
                      class="preview-meta-chip__swatch"
                      :style="{ background: widget.params.Color }"
                    ></span>
                    {{ currentColorName }}
                  </div>

                  <div class="preview-meta-chip">
                    {{ previewAspectLabel }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-actions class="setting-dialog__actions">
          <v-spacer></v-spacer>

          <v-btn
            text
            class="setting-btn setting-btn--ghost"
            @click="setting = false"
          >
            Cancel
          </v-btn>

          <v-btn
            depressed
            class="setting-btn setting-btn--primary"
            @click="saveWidgetSettings"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueDragResize from "vue-drag-resize";
import { mapState } from "vuex";
import WeatherStation from "../widgets/WeatherStation.vue";
import Lamp from "../widgets/Lamp.vue";
import ToggleSwitch from "../widgets/ToggleSwitch.vue";
import Gauge from "../widgets/ApexGauge.vue";
import Chart from "../widgets/AreaChart1.vue";
import TextInput from "../widgets/TextInput.vue";
import SilderHorizontal from "../widgets/Silder.vue";
import TimeInput from "../widgets/TimeInput.vue";
import Step from "../widgets/StepInput.vue";
import ValueDisplay from "../widgets/ValueDisplay.vue";

export default {
  props: ["widget"],
  components: {
    VueDragResize,
    WeatherStation,
    Lamp,
    ToggleSwitch,
    Gauge,
    Chart,
    TextInput,
    SilderHorizontal,
    TimeInput,
    Step,
    ValueDisplay,
  },

  computed: {
    ...mapState(["pageId", "devices", "widgets", "channel"]),

    resizeSticks() {
      return this.$store.state.edit ? ["tl", "tr", "br", "bl"] : [];
    },

    showSettingButton() {
      return (
        !this.$store.state.edit &&
        !this.$store.state.deleteMode &&
        !this.$store.state.addMode &&
        this.$store.state.webtype === "PC"
      );
    },

    cardClasses() {
      return {
        "delete-mode-card": this.$store.state.deleteMode,
        "move-mode-card": this.$store.state.edit,
      };
    },

    bodyClasses() {
      return {
        "widget-body": true,
        "widget-body--blurred":
          this.$store.state.edit || this.$store.state.deleteMode,
      };
    },

    contentClasses() {
      return {
        "widget-content": true,
        "widget-content--disabled":
          this.$store.state.edit ||
          this.$store.state.addMode ||
          this.$store.state.deleteMode,
      };
    },

    availableTopicItems() {
      const topics = (this.channel || [])
        .map((item) => (typeof item === "string" ? item : item && item.channel))
        .filter((topic) => typeof topic === "string" && topic.trim() !== "");

      return [...new Set(topics)].map((topic) => ({
        text: topic,
        value: topic,
      }));
    },

    availableOrderOptions() {
      const pageWidgets = this.widgets
        .filter((w) => w.pageId == this.pageId && w.show !== false)
        .slice()
        .sort((a, b) => a.id - b.id);

      return pageWidgets.map((_, index) => index + 1);
    },

    currentColorName() {
      const color = this.widget?.params?.Color;
      if (!color) return "เลือกสี";
      const colorName = Object.keys(this.colorHexMap).find(
        (key) => this.colorHexMap[key] === color
      );
      return colorName || color;
    },

    previewIcon() {
      const map = {
        Lamp: "mdi-lightbulb-outline",
        ToggleSwitch: "mdi-toggle-switch-outline",
        Gauge: "mdi-gauge",
        Chart: "mdi-chart-line",
        TextInput: "mdi-form-textbox",
        SilderHorizontal: "mdi-tune-variant",
        TimeInput: "mdi-timer-outline",
        Step: "mdi-plus-box-outline",
        ValueDisplay: "mdi-numeric",
        WeatherStation: "mdi-weather-partly-cloudy",
      };
      return map[this.widget.type] || "mdi-view-dashboard-outline";
    },

    previewAccentColor() {
      if (this.hasParams() && this.widget.params.Color) {
        return this.widget.params.Color;
      }

      const fallback = {
        Lamp: "#7e57c2",
        ToggleSwitch: "#42a5f5",
        Gauge: "#26a69a",
        Chart: "#ffa726",
        TextInput: "#5c6bc0",
        SilderHorizontal: "#ab47bc",
        TimeInput: "#29b6f6",
        Step: "#ef5350",
        ValueDisplay: "#66bb6a",
        WeatherStation: "#26c6da",
      };

      return fallback[this.widget.type] || "#7e57c2";
    },

    previewAccentStyle() {
      return {
        background: `linear-gradient(135deg, ${this.previewAccentColor}, #d1c4e9)`,
        boxShadow: `0 0 0 4px ${this.hexToRgba(this.previewAccentColor, 0.14)}`,
      };
    },

    previewIconColor() {
      return this.previewAccentColor;
    },

    previewIconSize() {
      const w = this.widget?.size?.w || 180;
      const h = this.widget?.size?.h || 160;
      const minSide = Math.min(w, h);

      if (minSide >= 280) return 54;
      if (minSide >= 200) return 46;
      if (minSide >= 140) return 40;
      return 34;
    },

    previewAspectLabel() {
      const w = this.widget?.size?.w || 180;
      const h = this.widget?.size?.h || 160;
      return `${w} × ${h}`;
    },

    previewWidgetStyle() {
      return {
        borderColor: this.hexToRgba(this.previewAccentColor, 0.14),
      };
    },

    previewBoxStyle() {
      const w = this.widget?.size?.w || 180;
      const h = this.widget?.size?.h || 160;

      const maxW = 220;
      const maxH = 150;

      const scale = Math.min(maxW / w, maxH / h, 1);
      const boxW = Math.max(120, Math.round(w * scale));
      const boxH = Math.max(78, Math.round(h * scale));

      return {
        width: `${boxW}px`,
        height: `${boxH}px`,
        borderColor: this.hexToRgba(this.previewAccentColor, 0.24),
        background: `
          radial-gradient(circle at top, ${this.hexToRgba(this.previewAccentColor, 0.14)}, transparent 58%),
          linear-gradient(180deg, #fcfbff, #f6f2ff)
        `,
      };
    },
  },

  data() {
    return {
      setting: false,
      settingTab: 0,
      dragEnabled: false,
      editOrder: 1,
      load_type: [
        "Lamp",
        "Fan",
        "Pump",
        "Air Conditioner",
        "Heater",
        "Door Lock",
        "Motion Sensor",
      ],
      colorOptions: [
        "red",
        "blue",
        "green",
        "yellow",
        "orange",
        "purple",
        "black",
        "white",
      ],
      colorHexMap: {
        red: "#FF0000",
        blue: "#0000FF",
        green: "#008000",
        yellow: "#FFFF00",
        orange: "#FFA500",
        purple: "#800080",
        black: "#000000",
        white: "#FFFFFF",
      },
    };
  },

  beforeDestroy() {
    window.removeEventListener("mouseup", this.stopMove);
    window.removeEventListener("touchend", this.stopMove);
  },

  methods: {
    activate() {},

    deactivate() {},

    startMove() {
      if (!this.$store.state.edit) return;
      this.dragEnabled = true;
      window.addEventListener("mouseup", this.stopMove, { once: true });
      window.addEventListener("touchend", this.stopMove, { once: true });
    },

    stopMove() {
      this.dragEnabled = false;
      this.deactivate();
    },

    resize(rect) {
      this.widget.size.w = Math.round(rect.width);
      this.widget.size.h = Math.round(rect.height);
      this.widget.size.x = Math.round(rect.left);
      this.widget.size.y = Math.round(rect.top);
    },

    deleteWidget() {
      this.widgets
        .filter((f) => f.id == this.widget.id)
        .forEach((w) => {
          w.show = false;
        });
    },

    Setting() {
      this.settingTab = 0;
      this.editOrder = this.widget.id;
      this.setting = true;
    },

    hasParams() {
      return this.widget.params !== undefined;
    },

    setColor(color) {
      this.widget.params.Color = this.colorHexMap[color];
    },

    hexToRgba(hex, alpha = 1) {
      if (!hex) return `rgba(126, 87, 194, ${alpha})`;

      let c = hex.replace("#", "");
      if (c.length === 3) {
        c = c.split("").map((ch) => ch + ch).join("");
      }

      const num = parseInt(c, 16);
      const r = (num >> 16) & 255;
      const g = (num >> 8) & 255;
      const b = num & 255;

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },

    applyWidgetOrder() {
      let targetId = Number(this.editOrder);

      if (!Number.isFinite(targetId)) {
        targetId = this.widget.id;
      }

      const pageWidgets = this.widgets
        .filter((w) => w.pageId == this.pageId && w.show !== false)
        .slice()
        .sort((a, b) => a.id - b.id);

      if (!pageWidgets.length) return;

      const maxId = pageWidgets.length;
      if (targetId < 1) targetId = 1;
      if (targetId > maxId) targetId = maxId;

      const movingWidget = pageWidgets.find(
        (w) => w === this.widget || w.id === this.widget.id
      );
      if (!movingWidget) return;

      const remaining = pageWidgets.filter((w) => w !== movingWidget);

      remaining.splice(targetId - 1, 0, movingWidget);

      remaining.forEach((w, index) => {
        w.id = index + 1;
      });

      this.editOrder = movingWidget.id;
    },

    saveWidgetSettings() {
      this.applyWidgetOrder();
      this.setting = false;
    },
  },
};
</script>

<style>
.widget-card {
  position: relative !important;
  overflow: hidden !important;
}

.widget-body {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.widget-body > .v-list-item__content {
  position: absolute !important;
  top: 4px !important;
  left: 10px !important;
  right: 48px !important;
  z-index: 5;
  flex: 0 0 auto;
  display: block !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding: 0 !important;
  margin: 0 !important;
  text-align: left !important;
}

.widget-content {
  width: 100%;
  height: 100%;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  overflow: hidden;
  padding-top: 30px;
  box-sizing: border-box;
}

.widget-content > * {
  width: 100%;
  height: 100%;
  min-height: 0;
}

.widget-setting-wrap {
  position: absolute !important;
  top: 8px !important;
  right: 8px !important;
  left: auto !important;
  bottom: auto !important;
  z-index: 6 !important;
}

.widget-setting-btn {
  width: 34px !important;
  height: 34px !important;
  min-width: 34px !important;
  padding: 0 !important;
  border-radius: 999px !important;
  background: rgba(255, 255, 255, 0.96) !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12) !important;
}

.widget-setting-btn .v-icon {
  color: #757575 !important;
  font-size: 18px !important;
}

.delete-mode-card,
.move-mode-card {
  transition:
    box-shadow 0.18s ease,
    border-color 0.18s ease,
    transform 0.12s ease;
}

.delete-mode-card {
  border: 1px solid rgba(244, 67, 54, 0.85) !important;
  box-shadow: 0 0 0 1px rgba(244, 67, 54, 0.18) inset;
}

.move-mode-card {
  border: 1px solid rgba(255, 214, 0, 0.95) !important;
  box-shadow: 0 0 0 1px rgba(255, 214, 0, 0.2) inset;
}

.widget-body--blurred {
  filter: blur(1.8px) saturate(0.88);
  transition: filter 0.18s ease;
}

.widget-title {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.1;
  text-align: left !important;
}

.widget-subtitle {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 10px;
  line-height: 1.15;
  text-align: left !important;
}

.widget-content--disabled,
.widget-content--disabled * {
  pointer-events: none !important;
  user-select: none;
}

.delete-overlay,
.move-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-overlay {
  background: rgba(255, 255, 255, 0.08);
  cursor: pointer;
}

.move-overlay {
  background: transparent;
  pointer-events: none;
}

.delete-overlay__icon {
  font-size: 64px !important;
  border-radius: 999px;
  padding: 18px;
  color: rgba(211, 47, 47, 0.95) !important;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.move-overlay__inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.move-overlay__move-btn {
  width: 96px;
  height: 96px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  pointer-events: auto;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.move-overlay__move-btn:hover {
  transform: scale(1.06);
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.2);
}

.move-overlay__icon {
  font-size: 56px !important;
  color: rgba(255, 214, 0, 0.98) !important;
}

.vdr.active:before {
  outline: 1px dashed rgba(255, 214, 0, 0.65);
}

.vdr-stick {
  width: 14px !important;
  height: 14px !important;
  background: rgba(255, 255, 255, 0.98) !important;
  border: 2px solid rgba(255, 214, 0, 0.95) !important;
  border-radius: 999px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
  z-index: 30 !important;
}

.vdr-stick-tm,
.vdr-stick-mr,
.vdr-stick-bm,
.vdr-stick-ml {
  display: none !important;
}

/* dialog */
.setting-dialog-card {
  border-radius: 22px !important;
  overflow: hidden;
  box-shadow: 0 20px 54px rgba(28, 18, 45, 0.22) !important;
}

.setting-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px 18px;
  background: linear-gradient(
    180deg,
    rgba(124, 77, 255, 0.08),
    rgba(124, 77, 255, 0.02)
  );
}

.setting-dialog__header-left {
  min-width: 0;
}

.setting-dialog__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #7e57c2;
  margin-bottom: 6px;
}

.setting-dialog__title {
  font-size: 24px;
  font-weight: 700;
  color: #2f2a3a;
  line-height: 1.2;
}

.setting-dialog__subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #7b7488;
}

.setting-dialog__close {
  margin-top: -2px;
}

.setting-dialog__content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 20px;
  padding: 20px 24px 18px;
  background: #faf9fd;
}

.setting-dialog__main {
  min-width: 0;
}

.setting-dialog__preview {
  min-width: 0;
}

.setting-tabs {
  margin-bottom: 14px;
}

.setting-tabs-items {
  background: transparent !important;
}

.setting-section {
  background: #ffffff;
  border: 1px solid rgba(124, 77, 255, 0.08);
  border-radius: 18px;
  padding: 18px;
  margin-bottom: 16px;
  box-shadow: 0 4px 14px rgba(74, 58, 103, 0.04);
}

.setting-section:last-child {
  margin-bottom: 0;
}

.setting-section__title {
  font-size: 15px;
  font-weight: 700;
  color: #43385a;
  margin-bottom: 14px;
}

.setting-input .v-input__slot {
  border-radius: 14px !important;
  box-shadow: none !important;
}

.setting-color-box {
  border-radius: 16px;
  background: linear-gradient(180deg, #fcfbff, #f6f2ff);
  border: 1px solid rgba(124, 77, 255, 0.1);
  padding: 16px;
}

.setting-color-box__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.setting-color-box__label {
  font-size: 13px;
  color: #756c84;
}

.setting-color-box__preview {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.setting-color-box__name {
  font-size: 16px;
  font-weight: 700;
  color: #3a3348;
  margin-bottom: 14px;
}

.setting-color-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.setting-color-swatch {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  transition: transform 0.14s ease, box-shadow 0.14s ease;
}

.setting-color-swatch:hover {
  transform: translateY(-1px) scale(1.05);
}

.setting-color-swatch--active {
  outline: 3px solid rgba(124, 77, 255, 0.25);
  box-shadow: 0 0 0 3px rgba(124, 77, 255, 0.08);
}

.setting-empty {
  padding: 18px;
  border-radius: 14px;
  background: #faf7ff;
  color: #7a7287;
  font-size: 14px;
}

.preview-card {
  background: linear-gradient(180deg, #ffffff, #f8f4ff);
  border: 1px solid rgba(124, 77, 255, 0.08);
  border-radius: 20px;
  padding: 18px;
  box-shadow: 0 8px 20px rgba(72, 50, 116, 0.08);
  position: sticky;
  top: 0;
}

.preview-card__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #8e7bb5;
  margin-bottom: 12px;
}

.preview-card__widget {
  border-radius: 18px;
  background: white;
  border: 1px solid rgba(124, 77, 255, 0.08);
  padding: 14px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.4);
}

.preview-card__widget-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 10px;
}

.preview-card__widget-title {
  font-size: 15px;
  font-weight: 700;
  color: #342d42;
  line-height: 1.25;
  word-break: break-word;
}

.preview-card__widget-dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  flex: 0 0 auto;
}

.preview-card__widget-box {
  margin: 0 auto 14px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed rgba(126, 87, 194, 0.2);
  transition: all 0.18s ease;
}

.preview-card__widget-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.preview-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 30px;
  padding: 0 10px;
  border-radius: 999px;
  background: #f4efff;
  color: #5a4a7d;
  font-size: 12px;
  font-weight: 600;
}

.preview-meta-chip__swatch {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  display: inline-block;
}

.preview-meta-chip--color {
  background: #f8f4ff;
}

.setting-dialog__actions {
  padding: 14px 18px !important;
  background: #ffffff;
}

.setting-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 700;
  letter-spacing: 0;
  min-width: 96px;
}

.setting-btn--ghost {
  color: #6d647b !important;
}

.setting-btn--primary {
  background: linear-gradient(135deg, #7e57c2, #5e35b1) !important;
  color: white !important;
  box-shadow: 0 8px 20px rgba(94, 53, 177, 0.24);
}

@media (max-width: 960px) {
  .setting-dialog__content {
    grid-template-columns: 1fr;
  }

  .preview-card {
    position: static;
  }
}
</style>